import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

var customActions = {
  changePassword: {method: 'PUT', url: 'auth/password'},
  changeLanguage: {method: 'PUT', url: 'auth/language'}
}

export const AuthResource = () => {
  return Vue.resource('auth', {}, customActions)
}



// WEBPACK FOOTER //
// ./src/api/auth.js